'use client';

import StatusPage from '@/components/Common/StatusPage';
import { useEffect } from 'react';

/**
 * Replaces the root layout when it fails — must define html/body.
 * Cannot reuse Header/Footer (they depend on the broken layout).
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Global error boundary:', error);
  }, [error]);

  return (
    <html lang="it">
      <body
        style={{
          margin: 0,
          fontFamily: '"Titillium Web", system-ui, sans-serif',
          background: '#f7fbf9',
          color: '#1a1a1a',
          minHeight: '100vh',
        }}
      >
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-italia@2.12.1/dist/css/bootstrap-italia.min.css"
        />
        {/* Teal overrides — CDN BI primary is blue */}
        <style
          dangerouslySetInnerHTML={{
            __html: `
              :root {
                --teal: #008549;
                --tealDark: #006637;
                --tealLight: #eefcf5;
              }
              .it-status-page {
                min-height: 50vh;
                background: linear-gradient(180deg, #f7fbf9 0%, #ffffff 55%);
              }
              .it-status-page__card {
                background: #fff;
                border: 1px solid #d5ebe0;
                border-radius: 4px;
                box-shadow: 0 8px 24px rgba(3, 49, 58, 0.06);
              }
              .it-status-page__code { color: var(--tealDark); font-weight: 700; }
              .it-status-page__icon {
                width: 3rem; height: 3rem; border-radius: 50%;
                color: var(--tealDark); background: var(--tealLight);
              }
              .it-status-page .btn-primary {
                color: #fff !important;
                background-color: var(--teal) !important;
                border-color: var(--teal) !important;
                box-shadow: none !important;
              }
              .it-status-page .btn-primary:hover,
              .it-status-page .btn-primary:focus,
              .it-status-page .btn-primary:focus-visible,
              .it-status-page .btn-primary:active {
                color: #fff !important;
                background-color: var(--tealDark) !important;
                border-color: var(--tealDark) !important;
                box-shadow: none !important;
              }
              .it-status-page .btn-outline-primary {
                color: var(--teal) !important;
                background-color: transparent !important;
                border-color: var(--teal) !important;
                box-shadow: inset 0 0 0 2px var(--teal) !important;
              }
              .it-status-page .btn-outline-primary:hover,
              .it-status-page .btn-outline-primary:focus,
              .it-status-page .btn-outline-primary:focus-visible,
              .it-status-page .btn-outline-primary:active {
                color: #fff !important;
                background-color: var(--teal) !important;
                border-color: var(--teal) !important;
                box-shadow: inset 0 0 0 2px var(--teal) !important;
              }
            `,
          }}
        />
        <StatusPage
          variant="error"
          onRetry={reset}
          detail={
            process.env.NODE_ENV === 'development'
              ? error.message
              : error.digest
                ? `Codice: ${error.digest}`
                : null
          }
        />
      </body>
    </html>
  );
}
